// Constants for navigation menu items
export const MENU_ITEMS = {
  Home: "#top",
  "Mental Health": "#mental_health",
  "Who I Am": "#who_i_am",
  "What I Do": "#what_i_do",
  "Get in Touch": "#get_in_touch",
};
